import { JaaSMeeting } from '@jitsi/react-sdk';
import React from 'react'


export const ReunionAfiMed = (props) => {

    const { nombre, idAgenda } = props
    const handleJaaSIFrameRef = iframeRef => {
        iframeRef.style.border = '1px solid #3d3d3d';
        iframeRef.style.background = '#3d3d3d';
        iframeRef.style.height = '650px';
        iframeRef.style.marginBottom = '1px';
    };

    let meetingRoomName = idAgenda;
    let appID = "vpaas-magic-cookie-852bf9aa520046a285ef060458bc74df"

    const userInfo = {
        displayName: nombre
    };
    return (
        <>
            <div class="purple">
                <b>
                    <center>
                        Sólo resta hacer clic en el botón “Join meeting” (Entrar a la reunión)
                    </center>
                </b>
            </div>
            <JaaSMeeting
                appId={appID}
                roomName={meetingRoomName}
                //jwt = { YOUR_VALID_JWT }
                //domain={domain}
                configOverwrite={{
                    disableThirdPartyRequests: true,
                    disableLocalVideoFlip: true,
                    backgroundAlpha: 0.5

                }}
                interfaceConfigOverwrite={{
                    VIDEO_LAYOUT_FIT: 'nocrop',
                    MOBILE_APP_PROMO: false,
                    TILE_VIEW_MAX_COLUMNS: 4
                }}
                getIFrameRef={handleJaaSIFrameRef}
                userInfo={userInfo}
            />
            <div class="purple">
                <i>
                    Recordá tener activadas las opciones de cámara y micrófono.
                </i>
            </div>
        </>


    )
}
